module.exports = __webpack_public_path__ + "img/sign.7cb01f0b.png";